import loadCustomScript from "@/utils/loadCustomScript";
// drive script
loadCustomScript("https://accounts.google.com/gsi/client");
loadCustomScript("https://apis.google.com/js/api.js");
// dropbox script
loadCustomScript("https://www.dropbox.com/static/api/2/dropins.js", [
    { name: "id", value: "dropboxjs" },
    { name: "data-app-key", value: process.env.DROPBOX_APP_KEY },
]);
